var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-overlay",class:{ 'v-overlay--active': _vm.loading }},[_c('div',{staticClass:"v-overlay__scrim"}),(_vm.loading)?_c('div',{staticClass:"v-overlay__content w-100 h-100 align-items-center d-flex justify-content-center"},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"64"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }